<div [ngClass]="{'hide-menu': hideMenu}">


  <div *ngIf="salesSummary">
    <br />
    <table class="styled fullwidth sales-summary">
      <tr>
        <th></th>
        <th class="align-right">{{ 'Idag' | translate }}</th>
        <th class="align-right">{{ 'Denna veckan' | translate }}</th>
        <th class="align-right">{{ 'Denna månaden' | translate }}</th>
        <th class="align-right">{{ 'I år' | translate }}</th>
      </tr>
      <tr class="lighter-background smaller-text">
        <th rowspan="2">{{ 'Ordrar' | translate }}</th>
        <td class="ace-color align-right">{{utility.numberFormat(salesSummary.today.ace.orders)}}</td>
        <td class="ace-color align-right">{{utility.numberFormat(salesSummary.thisWeek.ace.orders)}}</td>
        <td class="ace-color align-right">{{utility.numberFormat(salesSummary.thisMonth.ace.orders)}}</td>
        <td class="ace-color align-right">{{utility.numberFormat(salesSummary.thisYear.ace.orders)}}</td>
      </tr>
      <tr class="lighter-background smaller-text">
        <td class="partner-color align-right">{{utility.numberFormat(salesSummary.today.partners.orders)}}</td>
        <td class="partner-color align-right">{{utility.numberFormat(salesSummary.thisWeek.partners.orders)}}</td>
        <td class="partner-color align-right">{{utility.numberFormat(salesSummary.thisMonth.partners.orders)}}</td>
        <td class="partner-color align-right">{{utility.numberFormat(salesSummary.thisYear.partners.orders)}}</td>
      </tr>


      <tr class="darker-background smaller-text">
        <th rowspan="2">{{ 'Försäljning' | translate }}</th>
        <td class="ace-color align-right">{{utility.numberFormat(salesSummary.today.ace.sales)}}</td>
        <td class="ace-color align-right">{{utility.numberFormat(salesSummary.thisWeek.ace.sales)}}</td>
        <td class="ace-color align-right">{{utility.numberFormat(salesSummary.thisMonth.ace.sales)}}</td>
        <td class="ace-color align-right">{{utility.numberFormat(salesSummary.thisYear.ace.sales)}}</td>
      </tr>
      <tr class="darker-background smaller-text">
        <td class="partner-color align-right">{{utility.numberFormat(salesSummary.today.partners.sales)}}</td>
        <td class="partner-color align-right">{{utility.numberFormat(salesSummary.thisWeek.partners.sales)}}</td>
        <td class="partner-color align-right">{{utility.numberFormat(salesSummary.thisMonth.partners.sales)}}</td>
        <td class="partner-color align-right">{{utility.numberFormat(salesSummary.thisYear.partners.sales)}}</td>
      </tr>


      <tr class="lighter-background smaller-text">
        <th rowspan="2">{{ 'Resultat' | translate }}</th>
        <td class="ace-color align-right">{{utility.numberFormat(salesSummary.today.ace.sales -
          salesSummary.today.ace.costs)}}</td>
        <td class="ace-color align-right">{{utility.numberFormat(salesSummary.thisWeek.ace.sales -
          salesSummary.thisWeek.ace.costs)}}</td>
        <td class="ace-color align-right">{{utility.numberFormat(salesSummary.thisMonth.ace.sales -
          salesSummary.thisMonth.ace.costs)}}</td>
        <td class="ace-color align-right">{{utility.numberFormat(salesSummary.thisYear.ace.sales -
          salesSummary.thisYear.ace.costs)}}</td>
      </tr>
      <tr class="lighter-background smaller-text">
        <td class="partner-color align-right">{{utility.numberFormat(salesSummary.today.partners.sales -
          salesSummary.today.partners.costs)}}</td>
        <td class="partner-color align-right">{{utility.numberFormat(salesSummary.thisWeek.partners.sales -
          salesSummary.thisWeek.partners.costs)}}</td>
        <td class="partner-color align-right">{{utility.numberFormat(salesSummary.thisMonth.partners.sales -
          salesSummary.thisMonth.partners.costs)}}</td>
        <td class="partner-color align-right">{{utility.numberFormat(salesSummary.thisYear.partners.sales -
          salesSummary.thisYear.partners.costs)}}</td>
      </tr>


      <tr class="darker-background">
        <th class="positive-color">$$$</th>
        <th class="positive-color align-right">{{utility.numberFormat(salesSummary.today.sales -
          salesSummary.today.costs)}}</th>
        <th class="positive-color align-right">{{utility.numberFormat(salesSummary.thisWeek.sales -
          salesSummary.thisWeek.costs)}}</th>
        <th class="positive-color align-right">{{utility.numberFormat(salesSummary.thisMonth.sales -
          salesSummary.thisMonth.costs)}}</th>
        <th class="positive-color align-right">{{utility.numberFormat(salesSummary.thisYear.sales -
          salesSummary.thisYear.costs)}}</th>
      </tr>
    </table>
  </div>
  <br />

  <canvas baseChart *ngIf="dayGraphData" [datasets]="dayGraphData.datasets" [labels]="dayGraphData.labels"
    [options]="dayGraphData.options" [type]="dayGraphData.chartType">
  </canvas>
  <br />

  <canvas baseChart *ngIf="weekGraphData" [datasets]="weekGraphData.datasets" [labels]="weekGraphData.labels"
    [options]="weekGraphData.options" [type]="weekGraphData.chartType">
  </canvas>
  <br />

  <canvas baseChart *ngIf="monthGraphData && !hideMenu" [datasets]="monthGraphData.datasets"
    [labels]="monthGraphData.labels" [options]="monthGraphData.options" [type]="monthGraphData.chartType">
  </canvas>
  <br />

  <table class="styled fullwidth">
    <tr>
      <th>{{ 'Månad' | translate }}</th>
      <th class="align-right">{{ 'Försäljning' | translate }}</th>
      <th class="align-right">{{ 'Kostnader' | translate }}</th>
      <th class="align-right">{{ 'Resultat' | translate }}</th>
      <th class="align-right">{{ 'Marginal' | translate }}</th>
    </tr>
    <tr *ngFor="let month of totalsByMonth">
      <td>{{month.month}}</td>
      <td class="align-right">{{utility.currencyFormat(month.sales)}}</td>
      <td class="align-right">{{utility.currencyFormat(month.costs)}}</td>
      <td class="align-right">{{utility.currencyFormat(month.result)}}</td>
      <td class="align-right">{{(month.result / month.sales * 100).toFixed(1)}}%</td>
    </tr>
  </table>
  <br />
  <table class="styled fullwidth">
    <tr>
      <th>{{ 'År' | translate }}</th>
      <th class="align-right">{{ 'Försäljning' | translate }}</th>
      <th class="align-right">{{ 'Kostnader' | translate }}</th>
      <th class="align-right">{{ 'Resultat' | translate }}</th>
      <th class="align-right">{{ 'Marginal' | translate }}</th>
    </tr>
    <tr *ngFor="let year of totalsByYear | keyvalue">
      <td>{{year.key}}</td>
      <td class="align-right">{{utility.currencyFormat(year.value.sales)}}</td>
      <td class="align-right">{{utility.currencyFormat(year.value.costs)}}</td>
      <td class="align-right">{{utility.currencyFormat(year.value.result)}}</td>
      <td class="align-right">{{(year.value.result / year.value.sales * 100).toFixed(1)}}%</td>
    </tr>
  </table>

  <br />

  <div>
    <table class="fullwidth styled compact">
      <tr *ngFor="let order of latestOrders" (click)="newOrder()" [style.color]="storeColorById(order.storeId)">
        <td>{{order.created | date: 'yyyy-MM-dd HH:mm'}}</td>
        <td>{{order.shippingInfo.firstName}} {{order.shippingInfo.lastName}}</td>
        <td>{{storesById[order.storeId].name}}</td>
        <td>
          <div *ngFor="let item of order.items">{{item.quantity}}x {{item.name}}</div>
        </td>
      </tr>
    </table>
  </div>
</div>